export const setPov = "setPov";
export const setCenter = "setCenter";
export const setZoom = "setZoom";
export const setStyle = "setStyle";
export const setProjection = "setProjection";
export const setPixelTolerance = "setPixelTolerance";
export const setUser = "setUser";
export const setSettings = "setSettings";

export default {
  setPov,
  setCenter,
  setZoom,
  setStyle,
  setProjection,
  setPixelTolerance,
  setUser,
  setSettings
};
